import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DateConverterService } from '../shared/date/date-converter.service';
// import { Bank } from '../../base/bank';
import { LoanOdAccounts } from './loan-od-accounts.model';
import { LoanOdAccountsService } from './loan-od-accounts.service';
import { LoanOdAmendment } from './loan-od-amendment.model';

@Component({
    selector: 'jhi-loan-od-accounts-amend-tenure',
    templateUrl: './loan-od-accounts-amendtenure.component.html'
})
export class LoanOdAccountsAmendtenureComponent implements OnInit, OnDestroy {
    onError: any;
    //bank: Bank;
    bank: any;
    loanOdAccounts: LoanOdAccounts;
    loanOdAmendment: LoanOdAmendment;
    proceedIsTrue: boolean;
    proceedToResult: boolean;

    constructor(private loanODAccountsService: LoanOdAccountsService,
        private route: ActivatedRoute,
        private router: Router,
        private dateConverter: DateConverterService,
    ) {
        this.proceedIsTrue = false;
        this.proceedToResult = false;
    }
    ngOnInit() {
        this.loanOdAccounts = this.route.snapshot.data['loanOdAccounts'];
        this.loanOdAmendment = new LoanOdAmendment();
        this.loanOdAmendment.accountId = this.loanOdAccounts.accountId;
        this.loanOdAmendment.tenureMagnitude = this.loanOdAccounts.tenure.magnitude;
        this.loanOdAmendment.tenureUnit = this.loanOdAccounts.tenure.unit;
        this.loanODAccountsService.getBanks().subscribe(
            (res) => {
                this.setBank(res.json());
            });
    }
    ngOnDestroy() {
    }

    private setBank(data) {
        this.bank = data;
        this.loanOdAmendment.valueDate = this.dateConverter.fromServerToNgbDatePicker(this.bank.currentWorkingDate);
    }

    previousState() {
        window.history.back();
    }

    clear() {
        this.loanOdAccounts = new LoanOdAccounts();
        this.router.navigate(['/loan-od-accounts']);
    }

    proceed(loanOdAmendment) {
        this.loanOdAmendment = loanOdAmendment;
        this.loanOdAmendment.amendmentType = 'TENURE';
        this.loanOdAmendment.valueDate = this.dateConverter.fromNgbDatePickerToDateObject(this.loanOdAmendment.valueDate);
        this.proceedIsTrue = true;
    }

    back() {
        this.loanOdAmendment.valueDate = this.dateConverter.fromDateObjectToNgbDatePicker(this.loanOdAmendment.valueDate);
        this.proceedIsTrue = false;
    }

    executeError(error) {
        this.loanOdAmendment.valueDate = this.dateConverter.fromStringToNgbDatePicker(this.loanOdAmendment.valueDate);
        this.proceedIsTrue = false;
    }

    executeSuccess(result) {
        this.loanOdAmendment = result;
        this.proceedToResult = true;
    }
}
